module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Simon Morden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Dr. Simon Morden")]), _vm._v(" holds degrees in geology and planetary geophysics. He was born in Gateshead, England and now resides in Worthing, England. Find out more about Simon Morden at www.simonmorden.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kbfPgB/images/9780316134392.jpg?1732137048480",
      "alt": "This image is the cover for the book Equations of Life, Samuil Petrovitch"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Equations of Life, Samuil Petrovitch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Winner of the 2012 Philip K. Dick Award")]), _c('br'), _c('br'), _vm._v("Samuil Petrovitch is a survivor."), _c('br'), _c('br'), _vm._v("He survived the nuclear fallout in St. Petersburg and hid in the London Metrozone -- the last city in England. He's lived this long because he's a man of rules and logic."), _c('br'), _c('br'), _vm._v("For example, getting involved = a bad idea."), _c('br'), _c('br'), _vm._v("But when he stumbles into a kidnapping in progress, he acts without even thinking. Before he can stop himself, he's saved the daughter of the most dangerous man in London."), _c('br'), _c('br'), _vm._v("And clearly saving the girl = getting involved."), _c('br'), _c('br'), _vm._v("Now, the equation of Petrovitch's life is looking increasingly complex."), _c('br'), _c('br'), _vm._v("Russian mobsters + Yakuza + something called the New Machine Jihad = one dead Petrovitch."), _c('br'), _c('br'), _vm._v("But Petrovitch has a plan -- he always has a plan -- he's just not sure it's a good one.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0